<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Select, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar, isValidURL } from 'src/helpers/utilities';
	import { getWebIconStatuses } from 'src/helpers/virtual_helpers/virtual_icons_helpers';
	//Components
	import VCNameSettings from './VCNameSettings.svelte';
	import VCBooleanSettings from './VCBooleanSettings.svelte';
	import VCNumberSetting from './VCNumberSetting.svelte';
	import VCTextSettings from './VCTextSettings.svelte';
	import VCEnumSettings from './VCEnumSettings.svelte';
	import VcButtonSettings from './VCButtonSettings.svelte';
	import VcStatisticsSettings from './VCStatisticsSettings.svelte';
	import VcIconSettings from './VCIconSettings.svelte';
	//Types
	import type { VirtualComponentTypes, VirtualComponentInterface } from 'src/types/VirtualComponents';

	export let settings: VirtualComponentInterface['config'];
	export let type: VirtualComponentTypes;
	export let settingsError: boolean;
	export let component: string = null;
	export let editEnumModal = false;

	let errorMaxLen = false;
	let errorURLFalse = false;
	let errorURLTrue = false;
	let errorNumbers = false;

	$: errorURL =
		settings?.meta?.ui?.icon !== '' &&
		settings?.meta?.ui?.icon != null &&
		!isValidURL(settings.meta?.ui?.icon);
	$: settingsError = errorURL || errorMaxLen || errorNumbers || errorURLFalse || errorURLTrue;

	const persistOptions = [
		{
			title: $format('virtual_component_keep_after_reboot', {
				default: 'Keep current value after reboot',
			}),
			value: true,
		},
		{
			title: $format('virtual_component_default_after_reboot', {
				default: 'Use default value after reboot',
			}),
			value: false,
		},
	];

	const webIconStatuses = getWebIconStatuses();
	$: webIconStatus = webIconStatuses[settings?.meta?.ui?.webIcon] || webIconStatuses[0];
</script>

{#if !editEnumModal}
	<Text styleType="h2" class="mb-{component ? 's' : 'm'}">
		{$format(`sub_settings_title_${type}_virtual_component`, {
			default: `${capFirstChar(type)} virtual component`,
		})}
	</Text>
	{#if component}
		<Text styleType="body-small" class="mb-m">
			{settings?.addr || component}
		</Text>
	{/if}
	<VCNameSettings bind:settings label={component} />
{/if}
{#if type == 'number'}
	<VCNumberSetting bind:settings bind:settingsError={errorNumbers} />
{:else if type == 'boolean'}
	<VCBooleanSettings bind:settings bind:errorURLFalse bind:errorURLTrue />
{:else if type == 'text'}
	<VCTextSettings bind:settings bind:errorMaxLen />
{:else if type == 'enum'}
	<VCEnumSettings bind:settings bind:editEnumModal />
{:else if type == 'button'}
	<VcButtonSettings bind:settings />
{/if}

{#if !/^(button|bthomesensor|bthomedevice)$/.test(type) && !editEnumModal}
	<Text styleType="h2" class="mb-s">
		{$format('sub_settings_title_component_persisted', {
			default: 'Persisted',
		})}
	</Text>
	<Select
		aria-label={$format('select_component_persisted', {
			default: 'Select persisted',
		})}
		class="width-full mb-m"
		value={persistOptions.find((i) => i.value == settings.persisted) || persistOptions[0]}
		options={persistOptions}
		icon="fas fa-file-pen"
		on:change={(e) => {
			settings.persisted = e.detail['value'];
		}}
		id="select-a4a2gf6"
	/>
	<Text styleType="h2" class="mb-s">
		{$format('sub_settings_title_component_web_icon', {
			default: 'Web Icon',
		})}
	</Text>
	<Select
		aria-label={$format('select_component_web_icon', {
			default: 'Select web icon',
		})}
		size="m"
		class="mb-m"
		icon={webIconStatus.icon}
		value={webIconStatus}
		options={webIconStatuses}
		on:change={(e) => {
			settings.meta.ui.webIcon = e.detail['value'];
		}}
		id="select-iz0z9fz"
	/>
{/if}
{#if !editEnumModal}
	<VcIconSettings bind:settings {errorURL} />
	<VcStatisticsSettings {type} bind:settings />
{/if}
